<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemNotice.query.type')">
                <a-select
                  v-model="queryParam.noticeType"
                  :placeholder="$t('views.systemNotice.query.typePlaceholder')"
                  allow-clear
                  style="width: 100%"
                >
                  <a-select-option :value="1">{{ $t('views.systemNotice.type.notice') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('views.systemNotice.type.versionUpdate') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemNotice.query.title')">
                <a-input v-model="queryParam.noticeTitle" :placeholder="$t('views.systemNotice.query.titlePlaceholder')" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.systemNotice.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.systemNotice.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:notice:add']">
          <a-icon type="plus" />{{ $t('views.systemNotice.btn.add') }}
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['system:notice:edit']">
          <a-icon type="edit" />{{ $t('views.systemNotice.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:notice:remove']">
          <a-icon type="delete" />{{ $t('views.systemNotice.btn.delete') }}
        </a-button>
        <table-setting
          :key="$i18n.locale"
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />

      </div>
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }">
        <img style="width: 48px;height: 48px;" v-image-preview :src="record.imgUrl" slot="imgUrl" slot-scope="text, record">
        <a-switch slot="status" slot-scope="text, record" v-model="record.status" @change="onChange($event,record)" />
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:notice:edit']">
            <a-icon type="edit" />{{ $t('views.systemNotice.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['system:notice:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['system:notice:remove']">
            <a-icon type="delete" />{{ $t('views.systemNotice.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { pageNotice, delNotice, updateNotice } from '@/api/system/notice'
import { tableMixin } from '@/store/table-mixin'
import bus from '@/utils/bus'
import CreateForm from './modules/CreateForm'
export default {
  name: 'Notice',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      statusOptions: [
        {
          label: '正常',
          value: '0'
        }, {
          label: '停用',
          value: '1'
        }
      ],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      columns: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        noticeType: undefined,
        noticeTitle: undefined,
        noticeTitleEn: undefined,
        noticeContentEn: undefined,
        createBy: undefined,
        status: undefined
      }
    }
  },
  created () {
    this.buildColumns()
    this.getList()
    bus.$on('updateNoticeList', () => {
      this.getList()
    })
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    paginationShowTotal (total) {
      return this.$t('views.systemNotice.pagination.total', { total })
    },
    buildColumns () {
      this.columns = [
        {
          title: this.$t('views.systemNotice.column.id'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('views.systemNotice.column.type'),
          dataIndex: 'noticeType',
          align: 'center',
          customRender: (t) => {
            if (t === 1 || t === '1') {
              return this.$t('views.systemNotice.type.notice')
            }
            if (t === 2 || t === '2') {
              return this.$t('views.systemNotice.type.versionUpdate')
            }
            return t
          }
        },
        {
          title: this.$t('views.systemNotice.column.title'),
          dataIndex: 'noticeTitle',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.systemNotice.column.titleEn'),
          dataIndex: 'noticeTitleEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.systemNotice.column.image'),
          dataIndex: 'imgUrl',
          align: 'center',
          scopedSlots: { customRender: 'imgUrl' }
        },
        {
          title: this.$t('views.systemNotice.column.content'),
          dataIndex: 'noticeContent',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.systemNotice.column.contentEn'),
          dataIndex: 'noticeContentEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('views.systemNotice.column.status'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('views.systemNotice.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('views.systemNotice.column.operation'),
          dataIndex: 'operation',
          width: 160,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    onChange (e, record) {
      const recordData = JSON.parse(JSON.stringify(record))
      recordData.status = e ? 1 : 0
      this.updateBannerData(recordData)
    },
    updateBannerData (record) {
      updateNotice(record).then(() => {})
    },
    getList () {
      this.loading = true
      pageNotice(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        noticeType: undefined,
        noticeTitle: undefined,
        noticeTitleEn: undefined,
        noticeContentEn: undefined,
        createBy: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      var that = this
      const noticeIds = row.id || this.ids
      this.$confirm({
        title: this.$t('views.systemNotice.confirm.deleteTitle'),
        content: this.$t('views.systemNotice.confirm.deleteContent', { ids: noticeIds }),
        onOk () {
          return delNotice(noticeIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.systemNotice.msg.deleteSuccess'),
                3
              )
            })
        },
        onCancel () { }
      })
    }
  }
}
</script>
